import React from 'react';
import { SvgIcon } from '@mui/material';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { ReactComponent as icon } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/icon/info.svg';
import { useTranslation } from 'react-i18next';

const OpenClosedArrearsInfo = ({ arrears }: { arrears: Arrears }) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');
  const isOpen = arrears.reportingPeriodStatus === 'open';
  const message = isOpen
    ? 'commonInformationSection.openArrearsMessage'
    : 'commonInformationSection.closedArrearsMessage';

  return (
    <Body size="small" display="flex" alignItems="center" gap="10px" color="#483FCD">
      <SvgIcon
        component={icon}
        inheritViewBox
        aria-label="info icon"
        sx={{
          fontSize: 16,
          '& path': {
            fill: '#483FCD'
          }
        }}
      />
      {t(message)}
    </Body>
  );
};

export default OpenClosedArrearsInfo;
